<div class="w-full mx-auto p-5 space-y-5">

  <!-- Header -->
  <div class="flex flex-wrap justify-between items-end gap-4">
    <div>
      <div class="flex items-center gap-2 text-xs font-medium text-slate-500 uppercase tracking-wider">
        <span>Tesorería</span>
        <span class="text-slate-300">/</span>
        <span class="text-slate-700">Períodos Cerrados</span>
      </div>
      <h1 class="text-2xl font-semibold text-slate-900 mt-1">Períodos Cerrados</h1>
      <p class="text-sm text-slate-500 mt-1 tabular-nums">
        {{ filteredPeriods.length }} períodos · Cierres mensuales bancarios consolidados
      </p>
    </div>
  </div>

  <!-- Toolbar de filtros -->
  <div class="filters-toolbar">
    <div class="grid grid-cols-12 gap-3">

      <div class="col-span-12 md:col-span-5">
        <p-dropdown [options]="banks" [(ngModel)]="selectedBankId" optionLabel="bankName" optionValue="id"
          [showClear]="true" [filter]="true" placeholder="Todos los bancos" appendTo="body"
          panelStyleClass="filter-dropdown-panel" styleClass="w-full" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-6 md:col-span-3">
        <p-dropdown [options]="availableYears" [(ngModel)]="selectedYear" [showClear]="true"
          placeholder="Todos los años" appendTo="body" panelStyleClass="filter-dropdown-panel"
          styleClass="w-full" [style]="{'width':'100%'}">
        </p-dropdown>
      </div>

      <div class="col-span-6 md:col-span-4 flex gap-2">
        <button (click)="applyFilters()" class="btn btn-primary btn-sm flex-1">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          Filtrar
        </button>
        <button (click)="clearFilters()" class="btn btn-ghost btn-sm">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Limpiar
        </button>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="bg-white border border-slate-200 rounded-xl p-10 text-center">
    <svg class="animate-spin h-6 w-6 mx-auto mb-2 text-slate-400" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
    </svg>
    <p class="text-sm text-slate-500">Cargando períodos cerrados…</p>
  </div>

  <!-- Tabla -->
  <div *ngIf="!loading" class="rounded-xl border border-slate-200 bg-white overflow-x-auto">
    <table class="enrollment-table">
      <thead>
        <tr>
          <th>Banco</th>
          <th>Período</th>
          <th>Fecha de cierre</th>
          <th>Cerrado por</th>
          <th class="text-right">Total créditos</th>
          <th class="text-right">Total débitos</th>
          <th class="text-right">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let period of filteredPeriods">
          <td class="font-medium text-slate-800">{{ period.bank.bankName }}</td>
          <td>
            <span class="pill pill-sky">
              <i class="fas fa-calendar-check"></i>
              {{ getMonthName(period.month) }} <span class="tabular-nums">{{ period.year }}</span>
            </span>
          </td>
          <td class="text-slate-500 tabular-nums">{{ period.closedAt | date:'dd/MM/yy HH:mm' }}</td>
          <td class="text-slate-600 text-xs">{{ period.closedBy }}</td>
          <td class="text-right text-emerald-700 font-semibold tabular-nums">
            +{{ formatCurrency(period.totalCredits) }}
          </td>
          <td class="text-right text-rose-700 font-semibold tabular-nums">
            −{{ formatCurrency(period.totalDebits) }}
          </td>
          <td class="text-right">
            <button (click)="viewDetail(period)" class="row-action row-action--primary" title="Ver detalle del cierre">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.8">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
              </svg>
              <span>Detalle</span>
            </button>
          </td>
        </tr>

        <tr *ngIf="filteredPeriods.length === 0">
          <td colspan="7" class="text-center py-10">
            <div class="mx-auto w-12 h-12 rounded-full bg-slate-100 flex items-center justify-center mb-3">
              <svg class="w-6 h-6 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <p class="text-sm font-medium text-slate-700">No se encontraron períodos cerrados</p>
            <p class="text-xs text-slate-500 mt-1">Ajustá los filtros para ver resultados.</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Detail Modal -->
<p-dialog [(visible)]="showDetailModal" [modal]="true" [style]="{width: '720px'}" [draggable]="false"
  [resizable]="false" header="Detalle del Cierre" styleClass="period-detail-dialog">

  <div *ngIf="selectedPeriod" class="space-y-5">

    <!-- Period Info -->
    <div class="bg-slate-50 border border-slate-200 rounded-xl p-4">
      <div class="flex items-center gap-2 mb-2">
        <span class="pill pill-sky">
          <i class="fas fa-calendar-check"></i>
          {{ getMonthName(selectedPeriod.month) }} <span class="tabular-nums">{{ selectedPeriod.year }}</span>
        </span>
      </div>
      <h3 class="text-lg font-semibold text-slate-900">{{ selectedPeriod.bank.bankName }}</h3>
      <div class="grid grid-cols-2 gap-3 mt-3 text-sm">
        <div>
          <span class="text-xs text-slate-500 uppercase tracking-wider block">Fecha de cierre</span>
          <span class="text-slate-800 tabular-nums">{{ selectedPeriod.closedAt | date:'dd/MM/yy HH:mm' }}</span>
        </div>
        <div>
          <span class="text-xs text-slate-500 uppercase tracking-wider block">Cerrado por</span>
          <span class="text-slate-800">{{ selectedPeriod.closedBy }}</span>
        </div>
      </div>
    </div>

    <!-- Resumen financiero -->
    <div class="grid grid-cols-2 gap-3">
      <div class="kpi-card kpi-slate">
        <div class="kpi-label">
          <span class="kpi-icon"><i class="fas fa-arrow-right"></i></span>
          Saldo Inicial
        </div>
        <div class="kpi-value">{{ formatCurrency(selectedPeriod.startBalance) }}</div>
      </div>
      <div class="kpi-card kpi-sky">
        <div class="kpi-label">
          <span class="kpi-icon"><i class="fas fa-flag-checkered"></i></span>
          Saldo Final
        </div>
        <div class="kpi-value">{{ formatCurrency(selectedPeriod.endBalance) }}</div>
      </div>
      <div class="kpi-card kpi-emerald">
        <div class="kpi-label">
          <span class="kpi-icon"><i class="fas fa-plus"></i></span>
          Total Créditos
        </div>
        <div class="kpi-value">{{ formatCurrency(selectedPeriod.totalCredits) }}</div>
      </div>
      <div class="kpi-card kpi-rose">
        <div class="kpi-label">
          <span class="kpi-icon"><i class="fas fa-minus"></i></span>
          Total Débitos
        </div>
        <div class="kpi-value">{{ formatCurrency(selectedPeriod.totalDebits) }}</div>
      </div>
    </div>

    <!-- Notas -->
    <div *ngIf="selectedPeriod.notes"
      class="bg-amber-50/60 border border-amber-200 rounded-md p-3 flex items-start gap-2 text-sm">
      <i class="fas fa-info-circle text-amber-600 mt-0.5 flex-shrink-0"></i>
      <p class="text-amber-800">{{ selectedPeriod.notes }}</p>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button (click)="closeDetailModal()" class="btn btn-secondary">Cerrar</button>
  </ng-template>
</p-dialog>
